module.exports = __webpack_public_path__ + "assets/images/mo-7d730bbe37ce7fd57d62720c107be005.png";